
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'Page401'
})
export default class extends Vue {
  private message = '401 Page No Permission'

  private back() {
    if (this.$route.query.noGoBack) {
      this.$router.push({ path: '/dashboard' })
    } else {
      this.$router.go(-1)
    }
  }
}
